(function ($) {
  'use strict';

  /**
   * Menu Tray Controls
   */

  $('.js-menu-tray-toggle').menuTrayControls({
    class_animate_in: 'is-animate-in--from-end',
    class_animate_out: 'is-animate-out--from-end',
  });


  /**
   * Mobile Mega Menu - Prep Buttons & Containers
   */

  var $mobile_nav_dropdown_links = $('.mobile-nav > ul > li:is( .js-menu-item-mega, .menu-item-has-children ) > a');

  // Convert main nav dropdown links into buttons
  $mobile_nav_dropdown_links.each(function () {
    $(this).replaceWith( $( '<button class="js-mobile-menu-dropdown" aria-expanded="false" type="button">' + this.innerHTML + '</button>' ) );
  });

  // Get all buttons & dropdowns, for prep
  var $mobile_nav_dropdown_buttons = $('.mobile-nav .js-mobile-menu-dropdown');
  var $mobile_nav_dropdown_sub_menus = $('.mobile-nav > ul > li > ul.sub-menu, .mobile-nav .mega-menu-dropdown');

  // Prep buttons
  $mobile_nav_dropdown_buttons.each(function ( index ) {
    var $this = $(this);
    var $this_parent = $this.parent( 'li' );
    var $this_sub_menu = $this_parent.find( '> ul.sub-menu' );
    var parent_id = 'mobile-nav-dropdown-' + index;
    var this_button_id = parent_id + '-button';
    var this_sub_menu_id = parent_id + '-sub-menu';

    // Handle Products Mega Menu Dropdown
    if ( $this_parent.hasClass( 'js-menu-item-mega--products' ) ) {
      // aria-controls - Use mega menu container ID
      $this.attr( 'aria-controls', 'mobile-nav-products-mega-menu' );
      // Clone & Move mega menu under this sction, to preserve tab order & handle positioning
      $('#main-nav-products-mega-menu').clone()
        .appendTo( $this_parent )
        .attr( 'id', 'mobile-nav-products-mega-menu' );
      return true;
    }

    // Apply Aria Conrols ID for sub-menus
    $this_sub_menu.attr( 'id', this_sub_menu_id );
    $this.attr( 'id', this_button_id );
    $this.attr( 'aria-controls', this_sub_menu_id );
  });


  /**
   * Mobile Menu Dropdown Controls
   */

  // Update all buttons & dropdowns, for toggle
  $mobile_nav_dropdown_buttons = $('.mobile-nav .js-mobile-menu-dropdown');
  $mobile_nav_dropdown_sub_menus = $('.mobile-nav > ul > li > ul.sub-menu, .mobile-nav .mega-menu-dropdown');

  // Handle Clicks
  $mobile_nav_dropdown_buttons.on('click', function () {
    var $this = $(this);
    var $this_sub_menu = $( '#' + $this.attr( 'aria-controls' ) );
    var is_aria_expanded = ( $this.attr( 'aria-expanded' ) === 'true' ) || false;

    // Close all open
    $mobile_nav_dropdown_buttons.attr( 'aria-expanded', 'false' );
    $mobile_nav_dropdown_sub_menus.removeClass( 'is-active' );

    // Open just this
    if ( is_aria_expanded === false ) {
      $this.attr( 'aria-expanded', 'true' );
      $this_sub_menu.addClass( 'is-active' );
    }
  });

})(jQuery);
